import { ExpenseCategory, ExpenseTransaction } from '../../types';

export function getDueRecurringExpenseCategories(
  expenseCategories: ExpenseCategory[],
  expenses: ExpenseTransaction[],
  referenceDate: Date = new Date()
): ExpenseCategory[] {
  const today = referenceDate.getDate();
  const currentMonth = referenceDate.getMonth();
  const currentYear = referenceDate.getFullYear();

  return expenseCategories.filter(cat => {
    if (!cat.isRecurring || !cat.recurringDay) return false;
    const reminderDays = cat.reminderDaysBefore ?? 3;
    const reminderStart = cat.recurringDay - reminderDays;
    if (today < reminderStart) return false;
    return !expenses.some(e => {
      const d = new Date(e.date);
      return e.categoryId === cat.id && d.getMonth() === currentMonth && d.getFullYear() === currentYear;
    });
  });
}
